<div class="number_of_container">
  <input class="dynamic-form-item-input form-control dynamic_form_item_selector"
         [placeholder]=""
         (blur)="onBlur($event)"
         [type]="formConfig[0].type"
         [(ngModel)]="data[formConfig[0].name]"/>
  <label class="dynamic-form-item-label-out-of">of</label>
  <input class="dynamic-form-item-input form-control dynamic_form_item_selector"
         [placeholder]=""
         (blur)="onBlur($event)"
         [type]="formConfig[1].type"
         [(ngModel)]="data[formConfig[1].name]"/>
</div>
